import errorMessages from './errorMessages';
import { apigeeConfigs } from './setApigeeConfig';

const { ABORT_ERROR, ABORTED_ERROR_CODE } = errorMessages;

export function postToApigee(
	url: string,
	body: Record<string, unknown>,
	abortSignal: AbortSignal | null = null,
	contentType?: string
): Promise<Response> {
	return apigeeFetch(url, 'post', body, abortSignal, contentType);
}

export default function fetchFromApigee(url: string, abortSignal?: AbortSignal): Promise<Response> {
	return apigeeFetch(url, 'get', null, abortSignal);
}

const makeFetchCall = (url: string, options: RequestInit) =>
	window.fetch(`http${!apigeeConfigs.insecure ? 's' : ''}://${apigeeConfigs.host}/${url}`, options);

export function apigeeFetch(
	url: string,
	method: 'get' | 'post',
	body: Record<string, unknown> | Blob | null = null,
	signal: AbortSignal | null = null,
	contentType = 'application/json'
): Promise<Response> {
	const options: RequestInit = {
		headers: {
			'x-anwb-client-id': `${apigeeConfigs.client_id}`,
			...(contentType !== 'file' ? { 'content-type': contentType } : {}),
		},
		method,
		mode: 'cors',
		...(signal ? { signal } : {}),
	};

	if (body) {
		if (contentType === 'file') options.body = body as Blob;
		if (contentType === 'application/json') options.body = JSON.stringify(body);
	}

	const promise = makeFetchCall(url, options);

	/* eslint-disable consistent-return */
	promise.catch((error) => {
		// If aborted from abortSignal then do return an 'aborted' message
		if (error && error.name === ABORT_ERROR) {
			return Promise.reject(ABORTED_ERROR_CODE);
		}
	});

	return promise;
}
